export default {
    "profile": "Profil",
    "logout": "Keluar",
    "dashboard": "Dasbor",
    "password": "Kata sandi",
    "language": "Bahasa",
    "paymentbr": "Pembayaran",
    "subscriptionPaymentMethod": "Berlangganan & Metode Pembayaran",
    "nothingchanged": "Tidak ada yang berubah",
    "somethingWentWrong": "Ada yang salah ! Silakan coba lagi nanti",
    "pleaseTryAgainAfterSometime": "Silakan coba lagi suatu saat nanti",
    "noChanges": "Tidak berubah",
    "invalidEmailFormat": "Format email tidak valid",
    "chooseYourPreferredLanguage": "Silakan pilih bahasa pilihan Anda.",
    "selectLanguage": "Pilih bahasa",
    "update": "Memperbarui",
    "languagePreferences": "Preferensi Bahasa",
    "packageOf": "Paket Dari",
    "satelliteReport": "laporan satelit",
    "pastureReport": "laporan padang rumput",
    "upTo": "Hingga",
    "animals": "binatang",
    "back": "Kembali",
    "perMonth": "Per bulan",
    "perYear": "Per tahun",
    "continue": "Melanjutkan",
    "changePlan": "Ubah Rencana",
    "addOn": "Tambahan",
    "totalPrice": "Total harga",
    "availableAddOns": "Add-On yang Tersedia",
    "next": "Berikutnya",
    "congratulations": "Selamat",
    "done": "SELESAI",
    "deforestationComplianceAssessment": "Penilaian Kepatuhan Deforestasi",
    "warning": "Peringatan",
    "yourDataMightLost": "Data Anda mungkin hilang.",
    "clickOnSaveBtnMsg": "Klik tombol simpan untuk menyimpan data Anda",
    "discardChanges": "Membuang perubahan",
    "action": "Tindakan",
    "sendRequest": "Kirim Permintaan",
    "success": "Kesuksesan",
    "yourRequestSuccessfullySubmitted": "Permintaan Anda berhasil dikirimkan.",
    "informShortly": "Permintaan Anda telah berhasil dikirimkan. Laporan analisis Anda akan segera dikirimkan kepada Anda.",
    "search": "Mencari",
    "pending": "Tertunda",
    "approved": "Disetujui",
    "rejected": "ditolak",
    "primaryGeofence": "Geofence Utama",
    "Zero/Negligible Deforestation Probability": "Probabilitas Deforestasi Nol/Menyepelekan",
    "Low Deforestation Probability": "Probabilitas Deforestasi Rendah",
    "High Deforestation Probability": "Probabilitas Deforestasi Tinggi",
    "login": {
        "welcome": "Selamat datang! Gabung",
        "welInfo": "Masukkan kredensial Anda.",
        "login": "Gabung",
        "emailMobile": "Email/Ponsel",
        "forgotPassword": "Tidak ingat kata sandi",
        "register": "Daftar",
        "unableToLogin": "Tidak Dapat Masuk",
        "emailMobileCannotEmpty": "Email/Handphone wajib diisi.",
        "invalidEmailMobileFormat": "Format email/ponsel tidak valid.",
        "passwordCannotEmpty": "Kata sandi tidak boleh kosong.",
        "passwordLengthCanlessthan8": "Panjang kata sandi tidak boleh kurang dari 8 karakter.",
        "email": "Surel",
        "phone": "Telepon",
        "or": "ATAU",
        "alreadyHaveAccount": "Sudah memiliki akun",
        "loginNow": "Masuk sekarang",
        "registerOption": "Pilih opsi untuk mendaftar",
        "signUpWith": "Mendaftar dengan"
    },
    "user": {
        "profileUpdated": "Profil telah berhasil diperbarui",
        "profileNotUpdated": "Profil belum diperbarui",
        "otpSentOnEmail": "OTP berhasil dikirim!",
        "otpSentSuccessFully": "Kode OTP Anda telah terkirim",
        "unableToVerifyEmail": "Tidak dapat memverifikasi email",
        "emailCanNotBeEmpty": "Bidang email tidak boleh kosong",
        "firstName": "Nama depan",
        "lastName": "Nama keluarga",
        "email": "Surel",
        "mobile": "Seluler",
        "currentPassword": "kata sandi saat ini",
        "newPassword": "kata sandi baru",
        "repeatNewPassword": "Ulangi Kata Sandi Baru",
        "firstNameRequired": "Nama depan wajib diisi.",
        "lastNameRequired": "Nama belakang wajib diisi",
        "emailRequired": "Email diperlukan",
        "onlyAlphabet": "Hanya dapat berisi huruf",
        "notMoreThan15Char": "Tidak boleh lebih dari 15 karakter",
        "phoneCannotLessThan8Char": "Ponsel tidak boleh kurang dari 8 karakter",
        "countryCodeRequire": "Kode negara diperlukan",
        "changePassword": "Ganti kata sandi",
        "goodIdeaToUsePassword": "Sebaiknya gunakan kata sandi yang kuat yang tidak Anda gunakan di tempat lain.",
        "enterCurrentPassword": "Masukkan Kata Sandi Saat Ini",
        "enterNewPassword": "Masukan kata sandi baru",
        "reEnterPassword": "Masukkan Kembali password",
        "pleaseTypeOldPassword": "Silakan ketik kata sandi lama.",
        "pleaseTypeNewPassword": "Silakan ketik kata sandi baru.",
        "pleaseTypeConfirmPassword": "Silakan ketik konfirmasi kata sandi.",
        "passwordChangedSuccesFully": "Kata sandi berhasil diubah",
        "passwordDoesNotMatch": "Kata sandi tidak cocok.",
        "passwordRequired": "katakunci dibutuhkan",
        "emailOrPhoneIsRequired": "Email atau Nomor Telepon diperlukan"
    },
    "subscription": {
        "subscription": "Berlangganan",
        "membershipPlan": "Rencana Keanggotaan",
        "currentMembershipPlan": "Paket keanggotaan saat ini",
        "validUpTo": "Berlaku Hingga",
        "viewAllAddOns": "LIHAT SEMUA TAMBAHAN",
        "renewValidity": "Perbarui Validitas",
        "buyNow": "Beli sekarang",
        "upgradeMembershipPlan": "Tingkatkan paket keanggotaan",
        "chooseYourMembershipPlan": "Paket Keanggotaan Pilihan Anda",
        "chooseOptionalAddOns": "Anda dapat memilih Add-on opsional",
        "yourSelectedAddons": "Add-On Pilihan Anda",
        "addAnotherAddOn": "Tambahkan Pengaya Lainnya",
        "paymentMethod": "Cara Pembayaran",
        "addingAPaymentMethod": "Menambahkan Metode Pembayaran",
        "paymentSuccessful": "Pembayaran Anda Berhasil!",
        "weHaveEmailed": "Kami telah mengirimkan salinan tanda terima Anda melalui email ke example@email.com",
        "paymentAuthorizedSuccessfully": "Pembayaran berhasil diotorisasi.",
        "paymentSuccessfulPrompt": "Pembayaran berhasil. Paket ditingkatkan.",
        "paymentCancelled": "Pembayaran dibatalkan. Silakan coba lagi."
    },
    "registerFarm": "Daftarkan Peternakan",
    "requestDeforestationReport": "Meminta Laporan Deforestasi",
    "paymentMenu": "Pembayaran",
    "complianceCertificate": "Sertifikat Kepatuhan",
    "helpDisk": "Disk Bantuan",
    "faqs": "FAQ",
    "enquiries": "Pertanyaan",
    "contactUs": "Hubungi kami",
    "payment": {
        "basicPlan": "Paket Dasar",
        "advancePlan": "Rencana Lanjutan",
        "usdPerMonthPlus": "USD per bulan ditambah",
        "perReport": "per laporan",
        "deforestationAnalyticsCertificateDownload": "Unduhan sertifikat analisis deforestasi"
    },
    "farm": {
        "farmOwnershipType": "Jenis Kepemilikan Pertanian",
        "licenceNum": "Nomor Lisensi",
        "viewFarm": "Lihat Peternakan",
        "stateProvince": "Provinsi/Negara Bagian",
        "postalNumberShouldSimilarToFarm": "Nomor pos peternakan mirip dengan nomor rumah.",
        "videoTutorial": "Video tutorial",
        "clickOnMapMSG": "Klik pada peta untuk memulai geofencing",
        "prev": "Sebelumnya",
        "next": "Berikutnya",
        "dragVertexMsg": "Anda juga dapat menyeret titik puncaknya, atau menghapusnya menggunakan tombol hapus di sisi kanan. Geofence juga dapat dihapus menggunakan tombol hapus",
        "farmAddedSuccessfully": "Peternakan berhasil ditambahkan",
        "perimeter": "Perimeter",
        "area": "Daerah",
        "clearGeofence": "Hapus Geofence",
        "deleteSelectedVertex": "Hapus Vertex yang Dipilih",
        "pleaseStartDrawing": "Silakan mulai menggambar pembatasan wilayah di peta.",
        "chooseTheDate": "Pilih tanggalnya",
        "updateGeofenceForThisFarm": "PERBARUI GEOFENCE untuk peternakan ini",
        "farmUpdateSuccessfully": "Peternakan berhasil diperbarui",
        "farmZone": "Zona Pertanian",
        "addNewZones": "Tambahkan Zona Baru",
        "zoneName": "Nama Zona",
        "addZoneToCreate": "Silakan klik Tambahkan Zona untuk membuat Zona untuk peternakan ini.",
        "noZoneCreated": "Belum ada Zona yang dibuat.",
        "searchAndAddPin": "Cari dan tambahkan pin",
        "zoneNameWillBeHere": "Nama Zona akan ada di sini",
        "editZone": "Sunting Zona",
        "nameOfTheField": "Nama Bidang",
        "zoneDetails": "Detail Zona",
        "addZone": "Tambahkan Zona",
        "nameOfTheZone": "Nama Zona",
        "geofenceIsRequiredToAdd": "Geofence diperlukan untuk menambahkan zona. Klik `Edit Peternakan` untuk menambahkan detail Geofence ke peternakan Anda.",
        "thisFieldApplyHelpText": "Bidang ini hanya berlaku bagi Anda jika Anda tergabung dalam koperasi mana pun (Koperasi adalah perkumpulan otonom dari orang-orang yang bersatu secara sukarela untuk memenuhi kebutuhan dan aspirasi ekonomi, sosial dan budaya bersama melalui perusahaan yang dimiliki bersama dan dikendalikan secara demokratis). JIKA Anda tergabung dalam suatu koperasi, harap tunjukkan pengenal unik koperasi tersebut, dapat berupa nomor registrasi atau lisensi yang secara unik mengidentifikasi koperasi tempat Anda berasosiasi.",
        "farmRegistrationID": "ID Pendaftaran Peternakan",
        "farmerName": "Nama Petani",
        "farmerRegistrationID": "ID Pendaftaran Petani",
        "dateOfRequest": "Tanggal permintaan",
        "status": "Status",
        "address": "Alamat",
        "save": "Menyimpan",
        "farmAddress": "Alamat Lokasi Peternakan",
        "corporateName": "Nama perusahaan",
        "corporateMailingAddress": "Alamat Surat Perusahaan",
        "farmID": "ID Peternakan",
        "onTheFarm": "Di Peternakan",
        "userRoles": "Peran Pengguna",
        "adduser": "Tambahkan pengguna",
        "addAuser": "Tambahkan Pengguna",
        "uploadUsers": "Unggah Pengguna",
        "addNewUser": "Tambahkan pengguna baru",
        "selectDept": "Pilih Departemen",
        "selectRole": "Pilih Peran",
        "editUser": "Sunting Pengguna",
        "totalFarms": "Total Peternakan",
        "NoAnimalsRegisteredForthisFarm": "Tidak ada Hewan yang Terdaftar untuk Peternakan ini",
        "farmsPerPage": "Peternakan per halaman",
        "regularFarms": "Peternakan Biasa",
        "farmRegisteredProducts": "Produk Terdaftar Pertanian",
        "searchByFarmNameAndId": "Cari berdasarkan Nama dan Id Peternakan",
        "loadingProductsPleaseWait": "Memuat Produk... Harap tunggu",
        "farmName": "Nama Peternakan",
        "farmLocation": "Lokasi Peternakan",
        "productName": "Nama Produk",
        "stockStatus": "Status stok",
        "inStock": "Persediaan",
        "searchByProductName": "Cari Berdasarkan Nama Produk",
        "productCategory": "Kategori Produk",
        "products": "Produk",
        "yourLocationIsDisabled": "Lokasi Anda dinonaktifkan. Silakan cari lokasi Anda dari menu sebelah kiri.",
        "close": "Menutup",
        "farms": "Peternakan",
        "zones": "Zona",
        "registerAfarm": "Daftarkan Peternakan",
        "govtRegistry": "Pemerintah. Registri",
        "cooperativeID": "ID Koperasi/Serikat",
        "cooperativeName": "Nama Koperasi/Serikat",
        "farmType": "Jenis Peternakan",
        "contractMating": "Kontrak Kawin",
        "customization": "Kustomisasi",
        "recordsPerpage": "Catatan per Halaman",
        "restoreDefault": "Kembali ke awal",
        "apply": "Menerapkan",
        "CommunityName": "Nama komunitas",
        "searchState": "Cari berdasarkan ID Peternakan, Pendaftaran Pemerintah, ID Koperasi, Jenis Peternakan, Kontrak Kawin",
        "farmOwner": "Pemilik Peternakan",
        "govRegistrationNo": "Nomor Registrasi Pemerintah",
        "farmInformation": "Informasi Pertanian",
        "ownershipType": "Jenis Kepemilikan",
        "farmLicenseInformation": "Informasi Lisensi Pertanian",
        "licenseNumber": "Nomor lisensi",
        "licenseExpiryDate": "Tanggal Kedaluwarsa Lisensi",
        "regulatorName": "Nama Pengatur",
        "regulatorRepresentativeName": "Nama Perwakilan Regulator",
        "farmLocationSize": "Lokasi & Ukuran Peternakan",
        "productionSystem": "Sistem Pertanian",
        "country": "Negara",
        "state": "Negara",
        "city": "Desa/Kota/Kota",
        "farmNumber": "Nomor Peternakan",
        "postal": "Kode Pos/Kode Pos",
        "houseNumber": "Nomor rumah",
        "farmRegistration": "Pendaftaran Peternakan",
        "cancel": "Membatalkan",
        "register": "Daftar",
        "ok": "Oke",
        "totalFarmSize": "Total Ukuran Peternakan",
        "geographicLocation": "Lokasi geografis",
        "farmGeographicLocation": "Lokasi Geografis Pertanian",
        "perimeterPointLongitude": "Garis Bujur Titik Keliling",
        "perimeterPointLatitude": "Garis Lintang Titik Keliling",
        "perimeterPointLabel": "Label Titik Keliling",
        "perimeterLength": "Panjang Keliling",
        "farmLatitude": "Lintang Pertanian",
        "farmLongitude": "Bujur Pertanian",
        "latitude": "Garis Lintang",
        "longitude": "Garis bujur",
        "areaUnit": "Satuan Wilayah",
        "walkAndMeasure": "BERJALAN DAN MENGUKUR",
        "useGeofenceTool": "GUNAKAN ALAT GEOFENCE",
        "editFarm": "Sunting Pertanian",
        "update": "Memperbarui",
        "editAfarm": "Mengedit peternakan",
        "nextFarm": "Peternakan Berikutnya",
        "nameoftheFarm": "Nama Peternakan",
        "registerAProduct": " Daftarkan Produk",
        "farmProducts": "Produk Pertanian",
        "calf": "Anak sapi",
        "steer": "Mengarahkan",
        "heifer": "sapi betina",
        "sire": "Bapak",
        "dam": "Bendungan",
        "registerAnAnimal": "Daftarkan Hewan",
        "farmAnimals": "Hewan ternak",
        "farm_type": "Tipe pertanian",
        "farm_Owner": "Pemilik Peternakan",
        "dateOfRegistration": "Tanggal Pendaftaran",
        "dataIsNotAvailableForThisFarm": "Data Tidak tersedia untuk Peternakan ini",
        "registerNewProduct": "Daftarkan Produk Baru",
        "information": "Informasi",
        "licenseInfo": "Informasi Lisensi",
        "locationInfo": "Info Lokasi",
        "geoLocation": "Lokasi Geografis",
        "perimeterLengthState": "Panjang Keliling Peternakan (panjang pagar)",
        "totalFarmSizeState": "Ukuran Peternakan",
        "productionSystemState": "Sistem Produksi yang digunakan di Peternakan",
        "contractMatingState": "Kode Program Perkawinan Kontrak di mana Peternakan Berpartisipasi.",
        "ownershipTypeState": "Jenis kepemilikan",
        "regulatorRepresentativeNameState": "Nama orang yang mewakili regulator yang mengeluarkan izin",
        "regulatorNameState": "Nama regulator yang mengeluarkan izin",
        "licenseExpiryDateState": "Tanggal ketika Lisensi saat ini Kedaluwarsa",
        "licenseNumberState": "Nomor Lisensi yang dikeluarkan oleh Regulator",
        "plotNumberState": "Nomor rumah peternakan.",
        "plotNumber": "Nomor Peternakan",
        "streetStatement": "Nama jalan peternakan.",
        "cityStatement": "Kota tempat peternakan berada.",
        "stateStatement": "Wilayah negara tempat peternakan berada.",
        "countryState": "Negara tempat peternakan berada.",
        "farmStateInfo": "Alamat lokasi peternakan",
        "perimeterPointLongitudeState": "Bujur satu titik di lahan pertanian.",
        "perimeterPointLatitudeState": "Garis lintang satu titik di lahan pertanian.",
        "perimeterPointLabelState": "Label Titik.",
        "farmLongitudeState": "Bujur pertanian.",
        "farmLatitudeState": "Lintang pertanian.",
        "deleteFarm": "Hapus Peternakan",
        "corporateRegistrationNum": "Nomor Registrasi Perusahaan",
        "farmLocationIsRequired": "Lokasi Peternakan diperlukan."
    },
    "deforestation": {
        "addZoneToThisFarm": "Tambahkan Zona ke peternakan ini",
        "eudrForestAssessment": "Penilaian Hutan EUDR",
        "requestEudrForestAssessment": "MINTA PENILAIAN HUTAN EUDR",
        "pleaseChooseOption": "Silakan Pilih Opsi",
        "requestForestReport": "Minta Laporan Hutan",
        "noDeforestationReportMsg": "Tidak ada laporan deforestasi yang diminta. Mohon minta beberapa laporan deforestasi agar dapat dicantumkan di sini.",
        "allCountries": "Semua negara",
        "allRegions": "Semua wilayah",
        "allFarms": "Semua Peternakan",
        "allStatus": "Semua Status",
        "viewCertificate": "Lihat Sertifikat",
        "requestComplianceCertificate": "PERMINTAAN SERTIFIKAT KEPATUHAN",
        "assessmentNo": "Penilaian No",
        "blockchainCertificationInfo": "Hash Validasi Sertifikat Blockchain Akan Tersedia Setelah Sertifikat Diterima",
        "blockchainCertificationValidation": "Validasi Sertifikat Blockchain",
        "openBlockchainPage": "Buka Halaman Blockchain",
        "clickOnAboveLink": "Klik tautan di atas untuk memvalidasi sertifikat pada blockchain",
        "shareCertificate": "Bagikan Sertifikat",
        "hight": "Tinggi",
        "low": "Rendah",
        "zeroOrNegigible": "Nol atau Dapat Diabaikan",
        "deforestationProbability": "Kemungkinan Deforestasi",
        "colorCode": "Kode warna",
        "geofenceAarea": "Area Geofensi",
        "percentageOfGeofenceArea": "Persentase Area Geofence",
        "overallDeforestationProbability": "Kemungkinan Deforestasi Secara Keseluruhan",
        "deforestationComplianceReport": "Laporan Kepatuhan Deforestasi",
        "noDeforestationComplianceReport": "Tidak Ditemukan Laporan Kepatuhan Deforestasi",
        "loadingDeforestationComplianceReport": "Memuat eReport Kepatuhan Deforestasi",
        "farmRegistrationId": "ID Pendaftaran Peternakan",
        "farmerName": "Nama Petani",
        "farmerRegistrationId": "ID Pendaftaran Petani",
        "uniqueFarmerId": "ID Petani Unik",
        "uniqueFarmId": "ID Peternakan Unik",
        "farmLocation": "Lokasi Peternakan",
        "area": "Daerah",
        "farmAddress": "Alamat Peternakan",
        "dateOfRequest": "Tanggal permintaan",
        "status": "Status",
        "settings": "Pengaturan",
        "assignmentIssued": "Tugas Dikeluarkan",
        "certificateIssued": "Sertifikat Dikeluarkan",
        "complianceCertification": "Sertifikasi Kepatuhan",
        "noComplianceCertification": "Tidak Ditemukan Sertifikasi Kepatuhan",
        "loadingComplianceCertification": "Memuat Sertifikasi Kepatuhan",
        "assessmentReport": "Laporan Penilaian",
        "downloadPDF": "Unduh PDF",
        "print": "Mencetak",
        "back": "Kembali",
        "farmDetails": "Detail Pertanian",
        "dimitraFarmId": "Dimitra Farm Id",
        "dimitraFermerId": "Id Petani Dimitra",
        "totalGeofenceAreaHA": "Total Area Geofence (HA)",
        "forestLossHA": "Hilangnya Hutan (HA)",
        "forestGainHA": "Keuntungan Hutan (HA)",
        "forestUnchangedHA": "Hutan Tidak Berubah (HA)",
        "forestUnchanged": "Hutan Tidak Berubah",
        "forestLoss": "Hilangnya Hutan",
        "forestGain": "Keuntungan Hutan",
        "totalGeofenceArea": "Total Area Geofence",
        "forestAssessmentHelp": "Jika Anda memiliki pertanyaan tentang laporan ini atau memerlukan bantuan untuk memahaminya, hubungi kami melalui Help Desk.",
        "allReport": "Semua Laporan",
        "deforestationRepot": "Laporan Deforestasi",
        "requestDeforestationReportNow": "MINTA LAPORAN DEFORESTASI SEKARANG",
        "noRecordFound": "Tidak Ada Catatan yang Ditemukan",
        "noDeforestationReportRequested": "Tidak ada laporan deforestasi yang diminta. Mohon minta beberapa laporan deforestasi agar dapat dicantumkan di sini.",
        "deforestationImage": "Gambar Deforestasi",
        "reqDeforestationReport": "Meminta Laporan Deforestasi",
        "confirm": "Mengonfirmasi",
        "newForestArea": "Kawasan Hutan Baru",
        "deforestedArea": "Kawasan Terdeforestasi",
        "existingForestArea": "Kawasan Hutan yang Ada",
        "deforestation": "Penggundulan hutan",
        "farmName": "Nama Peternakan",
        "location": "Lokasi",
        "dateOfInterest": "Tanggal Minat",
        "geofenceArea": "Area Geofence (HA)",
        "deforestationArea": "Kawasan Deforestasi (HA)",
        "treeGainArea": "Area Perolehan Pohon (HA)",
        "currentForestArea": "Luas Hutan Saat Ini (HA)",
        "view": "Melihat",
        "locationInfoRequired": "Info Lokasi Diperlukan",
        "geofenceNameRequired": "Nama Geofence diperlukan",
        "futureDateSelected": "Tanggal mendatang dipilih",
        "reportGeneratedSuccessfully": "Laporan berhasil dibuat",
        "reportCannotAdded": "Laporan tidak dapat ditambahkan.",
        "primaryFarmNotFound": "Peternakan primer tidak ditemukan.",
        "pleaseRegisterFarmFirst": "Silakan daftarkan peternakan terlebih dahulu"
    },
    "certificate": {
        "allCertificate": "Semua Sertifikat",
        "certificate": "Sertifikat"
    }
}